import { getCompanyAppointmentUrlSegment } from '../../shared/booking/appointments/companyAppointmentRouting';

export const getStorefrontBookingConfirmationPath = (companyUrl, appointmentOrId, publicNumber) => {
  if (publicNumber != null && publicNumber !== '') {
    return `/book/${companyUrl}/booking/confirmed/${String(publicNumber)}`;
  }

  if (typeof appointmentOrId === 'string') {
    return `/book/${companyUrl}/booking/confirmed/${appointmentOrId}`;
  }

  const segment = getCompanyAppointmentUrlSegment(appointmentOrId);
  return `/book/${companyUrl}/booking/confirmed/${segment}`;
};
